import { DataBean } from "../DataBean";

export class UBLPaymentMeans extends DataBean {
    public async getUBLPaymentMeans(idUBLPaymentMeans: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.ubl.UBLPaymentMeans_getUBLPaymentMeans_Number", [idUBLPaymentMeans]);
    }

    public async deleteUBLPaymentMeans(idUBLPaymentMeans: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteUBLPaymentMeans_Number", [idUBLPaymentMeans]);
    }

    public async getUBLPaymentMeansCatalog(regexStr: string, page: number, recordsPerPage: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getUBLPaymentMeansCatalog_String_Number_Number", [regexStr, page, recordsPerPage]);
    }

}